import { Stack } from "@mui/material";
import { Link } from "react-router-dom";
import { logo } from "../utils/constants.js";
import MuiSearchBar from "./MuiSearchBar";

const MuiNavbar = () => (
  <Stack
    direction="row"
    alignItems="center"
    p={2}
    sx={{
      position: "sticky",
      background: "#000000",
      justifyContent: "space-between",
    }}
  >
    <Link to="./" style={{ display: "flex", alignItems: "center" }}>
      <img src={logo} alt="logo" height={45} />
    </Link>
    <MuiSearchBar />
  </Stack>
);

export default MuiNavbar;
